import React from 'react';
import classnames from 'classnames';

import styles from './index.css';

const MenuButton = ({ open, reverseColor, onClick = () => {} }) => (
	<div
		className={classnames(styles.menuButton, open ? styles.open : '')}
		role="button"
		tabIndex="0"
		onClick={onClick}
		onKeyPress={onClick}
	>
		<div className={classnames(styles.hamburger, reverseColor ? styles.reverse : '')}>
			<div className={styles.inner} />
		</div>
	</div>
);

export default MenuButton;



// WEBPACK FOOTER //
// ./src/components/atoms/MenuButton/index.js